import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

export class BodyScrollLock extends PureComponent {
  static propTypes = {
    children: PropTypes.any,
    isLocked: PropTypes.bool,
  };

  static defaultProps = {
    isLocked: true,
  };

  componentDidMount() {
    if (this.props.isLocked) {
      disableBodyScroll(this.targetElement);
    }
  }

  componentDidUpdate({ isLocked }) {
    if (isLocked !== this.props.isLocked) {
      if (!this.props.isLocked) {
        enableBodyScroll(this.targetElement);
        return;
      }
      disableBodyScroll(this.targetElement);
    }
  }

  componentWillUnmount() {
    clearAllBodyScrollLocks();
  }

  get targetElement() {
    return this.targetRef.current;
  }

  targetRef = React.createRef();

  render() {
    const childElement = React.Children.only(this.props.children);
    return React.cloneElement(childElement, { ref: this.targetRef });
  }
}
